import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-toggle",
  "use": "icon-toggle-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"icon-toggle\"><path d=\"M2.646 5.804h8.706c.187 0 .355-.11.425-.284a.455.455 0 0 0-.096-.497L8.933 2.276a.452.452 0 0 0-.645 0 .452.452 0 0 0 0 .645l1.967 1.967H2.652a.46.46 0 0 0-.329.782.45.45 0 0 0 .323.134Zm8.706 2.844H2.646a.456.456 0 0 0-.323.78l2.29 2.296a.451.451 0 0 0 .644 0 .451.451 0 0 0 0-.645L3.75 9.57h7.603a.46.46 0 0 0 .458-.458.466.466 0 0 0-.458-.464Z\" fill=\"#1890FF\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol